import React, { useState, useEffect, useRef } from "react";
import { Container, Table, Button, Form, Card } from "react-bootstrap";
import axios from "axios";
import moment from "moment";
import "moment-timezone";
import "bootstrap/dist/css/bootstrap.min.css";

const CORRECT_PASSWORD = "115560"; // Change this to your desired password
const EXPIRATION_TIME = 60 * 60 * 1000; // 1 hour in milliseconds

const Mody = () => {
  const [isauthenticate, setIsauthenticate] = useState(false);
  const [errorMSG, setErrorMSG] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savedRows, setSavedRows] = useState({});
  const pendingSaves = useRef({});
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => {
    const storedAuth = localStorage.getItem("authenticated");
    const storedTime = localStorage.getItem("auth_time");

    if (storedAuth === "true" && storedTime) {
      const currentTime = Date.now(); // Get current time in milliseconds
      const loginTime = parseInt(storedTime, 10); // Convert saved time to integer

      if (currentTime - loginTime < EXPIRATION_TIME) {
        setIsauthenticate(true);
      } else {
        localStorage.removeItem("authenticated");
        localStorage.removeItem("auth_time");
      }
    }
  }, []);

  useEffect(() => {
    if (!isauthenticate) return;
    const fetchServices = async () => {
      try {
        const response = await axios.get("https://api.viralgpt.com/boosts/services");
        setServices(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch services:", error);
        alert("Failed to fetch services: " + (error.response?.data?.error || error.message));
        setLoading(false);
      }
    };

    fetchServices();
  }, [isauthenticate]);

  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  const handleSave = async (service) => {
    if (pendingSaves.current[service.id]) return;

    try {
      pendingSaves.current[service.id] = true;

      if (service.lastChecked) {
        service.lastChecked = moment(service.lastChecked)
          .tz("Africa/Cairo")
          .format("YYYY-MM-DD");
      }

      await axios.post("https://api.viralgpt.com/boosts/services", service);

      setServices((prev) =>
        prev.map((s) => (s.id === service.id ? { ...s, ...service } : s))
      );

      setSavedRows((prev) => ({ ...prev, [service.id]: true }));
      setTimeout(() => setSavedRows((prev) => ({ ...prev, [service.id]: false })), 1000);
    } catch (error) {
      console.error("Failed to save service:", error);
      alert("Failed to update service: " + (error.response?.data?.error || error.message));
    } finally {
      delete pendingSaves.current[service.id];
    }
  };

  const handlePasswordSubmit = () => {
    if (enteredPassword === CORRECT_PASSWORD) {
      setIsauthenticate(true);
      localStorage.setItem("authenticated", "true");
      localStorage.setItem("auth_time", Date.now().toString());
      setErrorMSG("");
    } else {
      setEnteredPassword("");
      setErrorMSG("❌ Incorrect password. Please try again.");
    }
  };

  if (!isauthenticate) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
        <Card className="p-4 shadow border-0 rounded" style={{ width: "350px", backgroundColor: "#f8f9fa" }}>
          <h2 className="mb-3 text-primary">🔒 Enter Password</h2>
          {errorMSG && <p className="text-danger fw-bold">{errorMSG}</p>}
          <Form.Control
            type="password"
            value={enteredPassword}
            onChange={(e) => setEnteredPassword(e.target.value)}
            className="mb-3 text-center border rounded-pill shadow-sm p-2"
          />
          <Button onClick={handlePasswordSubmit} variant="primary" className="w-100 rounded-pill shadow">
            Submit
          </Button>
        </Card>
      </div>
    );
  }

  if (loading) return <div className="text-center mt-5 fw-bold text-muted">Loading, please wait...</div>;

  return (
    <Container fluid className={`py-4 ${darkMode ? "bg-dark text-light" : "bg-white text-dark" } ` }>
      <div className="d-flex justify-content-between align-items-center mb-4 p-3 border-bottom shadow-sm ">
        <h1 className="fw-bold text-primary">📋 Service Management</h1>
        <Button onClick={() => setDarkMode(!darkMode)} variant="outline-primary" className="shadow-sm rounded-pill">
          {darkMode ? "☀️ Light Mode" : "🌙 Dark Mode"}
        </Button>
      </div>
      <div className="table-responsive" style={{ maxHeight: "90vh", overflowY: "auto" }}>
        <Table striped bordered hover responsive variant={darkMode ? "dark" : "light"} className="shadow-sm rounded overflow-hidden">
          <thead className="table-primary text-uppercase text-center" style={{ position: "sticky", top: 0, zIndex: 1 }}>
            <tr>
              <th>Checked</th>
              <th>Name</th>
              <th>Service ID</th>
              <th>Price</th>
              <th>Min Qty</th>
              <th>Notes</th>
              <th>Avg Time</th>
              <th>Website</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {services.map((service) => (
              <tr key={service.id} style={{ backgroundColor: savedRows[service.id] ? "#90EE90" : undefined }}>
                <td>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                    <Form.Check
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          const newService = {
                            ...service,
                            lastChecked: moment().tz("Africa/Cairo").format("YYYY-MM-DD"),
                          };
                          setServices((prev) => prev.map((s) => (s.id === service.id ? newService : s)));
                          handleSave(newService);
                        } else {
                          const newService = { ...service, lastChecked: 0 };
                          setServices((prev) => prev.map((s) => (s.id === service.id ? newService : s)));
                          handleSave(newService);
                        }
                      }}
                      checked={moment(service.lastChecked).tz("Africa/Cairo").format("YYYY-MM-DD") === moment().tz("Africa/Cairo").format("YYYY-MM-DD")}
                      className="form-control-sm"
                    />
                  </div>
                </td>
                <td >{service.name}</td>
                <td className="text-center">
                  <Form.Control
                    type="number"
                    value={service.id}
                    onChange={(e) => setServices((prev) => prev.map((s) => (s.id === service.id ? { ...s, id: parseInt(e.target.value) } : s)))}
                    onBlur={(e) => handleSave({ ...service, id: parseInt(e.target.value) })}
                    className="form-control-sm mx-auto"
                    style={{ width: "100px" }}
                  />
                </td>
                <td className="text-center">
                  <Form.Control
                    type="number"
                    value={service.price}
                    onChange={(e) => setServices((prev) => prev.map((s) => (s.id === service.id ? { ...s, price: parseFloat(e.target.value) } : s)))}
                    onBlur={(e) => handleSave({ ...service, price: parseFloat(e.target.value) })}
                    className="form-control-sm mx-auto"
                    style={{ width: "100px" }}
                  />
                </td>
                <td className="text-center">
                  <Form.Control
                    type="number"
                    value={service.minimumQuantity}
                    onChange={(e) => setServices((prev) => prev.map((s) => (s.id === service.id ? { ...s, minimumQuantity: parseInt(e.target.value) } : s)))}
                    onBlur={(e) => handleSave({ ...service, minimumQuantity: parseInt(e.target.value) })}
                    className="form-control-sm mx-auto"
                    style={{ width: "100px" }}
                  />
                </td>
                <td className="text-center">
                  <Form.Control
                    as="textarea"
                    rows={1}
                    value={service.notes}
                    onChange={(e) => setServices((prev) => prev.map((s) => (s.id === service.id ? { ...s, notes: e.target.value } : s)))}
                    onBlur={(e) => handleSave({ ...service, notes: e.target.value })}
                    className="form-control-sm mx-auto"
                  />
                </td>
                <td className="text-center">
                  <Form.Control
                    value={service.averageTime}
                    onChange={(e) => setServices((prev) => prev.map((s) => (s.id === service.id ? { ...s, averageTime: e.target.value } : s)))}
                    onBlur={(e) => handleSave({ ...service, averageTime: e.target.value })}
                    className="form-control-sm mx-auto"
                    style={{ width: "100px" }}
                  />
                </td>
                <td className="text-center">{service.website}</td>
                <td className="text-center">
                  <Button size="sm" variant="success" onClick={() => handleSave(service)}>
                    Save
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default Mody;